// Styles
import { ReactNode } from "react";
import { AtomSpinner } from "react-epic-spinners";
import { Wrapper } from "./styles";

type LoadingProps = {
  loading: boolean;
  cor: string;
  children: ReactNode;
};

export default function Loading({ loading, cor, children }: LoadingProps) {
  return <Wrapper>{loading ? <AtomSpinner color={cor} /> : children}</Wrapper>;
}
